import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ClientStateService {
  readonly clientId = signal<string | null>(null);
  readonly riskClientId = signal<string | null>(null);
  readonly clientEmail = signal<string | null>(null);
  readonly pan = signal<string | null>(null);
  readonly selectedClientIds = signal<readonly string[]>([]);
  readonly showFatca = signal(false);

  selectClient(clientId: string | null): void {
    this.clientId.set(clientId);
  }

  selectRiskClient(clientId: string | null): void {
    this.riskClientId.set(clientId);
  }

  setClientEmail(email: string | null): void {
    this.clientEmail.set(email);
  }

  setPan(pan: string | null): void {
    this.pan.set(pan);
  }

  setSelectedClientIds(clientIds: readonly string[]): void {
    this.selectedClientIds.set([...clientIds]);
  }

  setShowFatca(showFatca: boolean): void {
    this.showFatca.set(showFatca);
  }

  reset(): void {
    this.clientId.set(null);
    this.riskClientId.set(null);
    this.clientEmail.set(null);
    this.pan.set(null);
    this.selectedClientIds.set([]);
    this.showFatca.set(false);
  }
}
